import axios from 'axios';
import config from '../config';

// axios.defaults.baseURL = 'http://brightness.mynetgear.com:8081/hz/';
// axios.defaults.baseURL = 'http://hz.richcyber.com:8081/hz/';
axios.defaults.baseURL = config.axiosBaseUrl;
// axios.defaults.baseURL = 'http://192.168.0.8:8080/hzbj'
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('viewToken');
  if (token) {
    config.headers.token = token;
  }

  return config;
}),
  (error) => {
    return Promise.error(error);
  };

axios.interceptors.request.use(
  (res) => {
    let cancel;
    res['cancelToken'] = new axios.CancelToken(function (c) {
      cancel = c;
    });
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
      if (res.url == '/onlineExhibition/addCollect') {
        const viewToken = localStorage.getItem('viewToken');
        if (!viewToken) {
          return Promise.reject('noLogin');
        } else {
          delete res.cancelToken;
          return res;
        }
      } else {
        delete res.cancelToken;
        return res;
      }
    } else {
      delete res.cancelToken;
      return res;
    }
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.request.use((response) => {
  return response;
}),
  (error) => {
    return Promise.error(error);
  };
export default axios;
